import FormButtonField from "./fields/Form/ButtonField.vue"
import FormButtonsField from "./fields/Form/ButtonsField.vue"

const buttonFieldSetup = (app) => {

    /**
     * Register Fields
     */
    app.component('form-button-field', FormButtonField)
    app.component('form-buttons-field', FormButtonsField)
}

export { buttonFieldSetup }